(function() {
  var VERSION = '2026-05-21-aidesigner-port';

  if (window.__AMG_ONE_PUTT_REBUILD_V2__ === VERSION) return;
  window.__AMG_ONE_PUTT_REBUILD_V2__ = VERSION;
  window.__AMG_ONE_PUTT_REBUILD__ = true;

  var PRODUCT = {
    title: 'One Putt Trainer',
    variantId: 41874775769240,
    price: '$99.99',
    video: 'https://cdn.shopify.com/videos/c/vp/3231c1e9d129456ba7184ef234774c68/3231c1e9d129456ba7184ef234774c68.HD-720p-3.0Mbps-10752525.mp4',
    videoPoster: 'https://cdn.shopify.com/s/files/1/0523/7542/1080/products/3231c1e9d129456ba7184ef234774c68.thumbnail.0000000000.jpg?v=1669231857',
    images: [
      'https://cdn.shopify.com/s/files/1/0523/7542/1080/products/one-putt-trainer-277798.jpg?v=1669400598',
      'https://cdn.shopify.com/s/files/1/0523/7542/1080/products/one-putt-trainer-983792.jpg?v=1669400598',
      'https://cdn.shopify.com/s/files/1/0523/7542/1080/products/one-putt-trainer-132056.jpg?v=1669400598',
      'https://cdn.shopify.com/s/files/1/0523/7542/1080/products/one-putt-trainer-772039.jpg?v=1669400598'
    ]
  };

  function ready(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback);
    } else {
      callback();
    }
  }

  function isOnePuttPage() {
    return window.location.pathname.indexOf('/products/one-putt-trainer') !== -1 ||
      document.title.toLowerCase().indexOf('one putt trainer') !== -1;
  }

  function img(src, alt, className, loading) {
    return '<img class="' + className + '" src="' + src + '" alt="' + alt + '" loading="' + loading + '" width="1200" height="900">';
  }

  function thumb(index, label) {
    return [
      '<button type="button" class="amg-opt-thumb" data-gallery-index="' + index + '" aria-label="' + label + '">',
        img(PRODUCT.images[index], label, 'amg-opt-thumb__image', 'lazy'),
      '</button>'
    ].join('');
  }

  function renderPage(root) {
    root.classList.add('amg-opt-rebuilt');
    root.classList.remove('opt-rebuilt');
    root.setAttribute('data-amg-opt-version', VERSION);

    root.innerHTML = [
      '<main class="amg-opt-page" data-product="one-putt-trainer">',
        '<section class="amg-opt-hero" id="top">',
          '<div class="amg-opt-hero__copy">',
            '<p class="amg-opt-kicker">AMG Putting Trainer</p>',
            '<h1>One Putt Trainer</h1>',
            '<p class="amg-opt-headline">Make every practice putt tell you something.</p>',
            '<p class="amg-opt-lede">A portable AMG putting aid built to give your reps a clear job: start line, face control, alignment, speed, and read. Less guessing. More useful feedback.</p>',
            '<div class="amg-opt-proof-strip" aria-label="Product highlights">',
              '<span>' + PRODUCT.price + '</span>',
              '<span>Fits in your golf bag</span>',
              '<span>Practice green or home mat</span>',
            '</div>',
            '<div class="amg-opt-buy-card" id="buy">',
              '<div class="amg-opt-price-block">',
                '<span>Available now</span>',
                '<strong>' + PRODUCT.price + '</strong>',
              '</div>',
              '<div class="amg-opt-qty" aria-label="Quantity selector">',
                '<button type="button" data-qty-minus aria-label="Decrease quantity">-</button>',
                '<input type="number" value="1" min="1" inputmode="numeric" aria-label="Quantity">',
                '<button type="button" data-qty-plus aria-label="Increase quantity">+</button>',
              '</div>',
              '<button type="button" class="amg-opt-button" data-add-to-cart>Get The One Putt Trainer</button>',
              '<p class="amg-opt-status" data-cart-status role="status" aria-live="polite"></p>',
            '</div>',
          '</div>',

          '<div class="amg-opt-hero__media">',
            '<figure class="amg-opt-product-stage">',
              img(PRODUCT.images[1], 'Open One Putt Trainer kit with the training pieces inside the carry case', 'amg-opt-product-stage__image', 'eager'),
              '<figcaption><strong>Everything in one case</strong><span>Set up a focused putting station without a bag full of gadgets.</span></figcaption>',
            '</figure>',
            '<div class="amg-opt-thumbs" aria-label="Product gallery thumbnails">',
              thumb(1, 'Open One Putt Trainer kit'),
              thumb(0, 'One Putt Trainer carry case'),
              thumb(2, 'One Putt Trainer on putting green'),
              thumb(3, 'Golfer practicing with the One Putt Trainer'),
            '</div>',
          '</div>',
        '</section>',

        '<section class="amg-opt-band amg-opt-band--problem">',
          '<div class="amg-opt-section">',
            '<div class="amg-opt-section__intro">',
              '<p class="amg-opt-kicker">The miss is not enough</p>',
              '<h2>Random reps do not tell you what broke.</h2>',
              '<p>You can miss a putt from a bad read, bad speed, poor aim, or a face that never matched your intention. The One Putt Trainer gives the ball a defined task so each rep produces feedback you can use.</p>',
            '</div>',
            '<div class="amg-opt-matrix" aria-label="Practice feedback areas">',
              '<article><span>01</span><h3>Start line</h3><p>Train the ball to launch through the window you actually picked.</p></article>',
              '<article><span>02</span><h3>Face control</h3><p>Make face delivery part of the drill instead of a vague feeling.</p></article>',
              '<article><span>03</span><h3>Alignment</h3><p>Give setup and aim a visual reference before the stroke starts.</p></article>',
              '<article><span>04</span><h3>Speed and read</h3><p>Blend pace with the line instead of practicing one in isolation.</p></article>',
            '</div>',
          '</div>',
        '</section>',

        '<section class="amg-opt-section amg-opt-demo">',
          '<div class="amg-opt-demo__copy">',
            '<p class="amg-opt-kicker">Watch it work</p>',
            '<h2>The video is vertical, so it belongs in a focused demo frame.</h2>',
            '<p>This keeps the hero clean and lets the product video do what it is supposed to do: show the setup, the gates, and the feedback loop without being stretched into the wrong shape.</p>',
            '<ul class="amg-opt-demo-list">',
              '<li><strong>Set the target</strong><span>Create the start-line challenge.</span></li>',
              '<li><strong>Roll the rep</strong><span>Let the trainer define a successful launch.</span></li>',
              '<li><strong>Adjust the next ball</strong><span>Use the miss to sharpen the drill.</span></li>',
            '</ul>',
          '</div>',
          '<div class="amg-opt-demo__media">',
            '<div class="amg-opt-phone-frame">',
              '<video class="amg-opt-video" controls playsinline preload="metadata" poster="' + PRODUCT.videoPoster + '">',
                '<source src="' + PRODUCT.video + '" type="video/mp4">',
              '</video>',
            '</div>',
          '</div>',
        '</section>',

        '<section class="amg-opt-band">',
          '<div class="amg-opt-section amg-opt-split">',
            '<div class="amg-opt-split__media">',
              img(PRODUCT.images[3], 'Golfer practicing with the One Putt Trainer on a green', 'amg-opt-feature-image', 'lazy'),
            '</div>',
            '<div class="amg-opt-split__copy">',
              '<p class="amg-opt-kicker">Simple practice loop</p>',
              '<h2>Set it down. Roll the putt. Let the result coach the next rep.</h2>',
              '<ol class="amg-opt-steps">',
                '<li><span>1</span><div><strong>Build the gate</strong><p>Create a clear launch challenge before you hit the putt.</p></div></li>',
                '<li><span>2</span><div><strong>Roll with intent</strong><p>Practice face, aim, line, and pace with one obvious task.</p></div></li>',
                '<li><span>3</span><div><strong>Adjust immediately</strong><p>The result tells you what deserves attention on the next ball.</p></div></li>',
              '</ol>',
            '</div>',
          '</div>',
        '</section>',

        '<section class="amg-opt-section amg-opt-kit">',
          '<div class="amg-opt-kit__copy">',
            '<p class="amg-opt-kicker">What you get</p>',
            '<h2>A complete trainer that travels with your clubs.</h2>',
            '<p>AMG built the One Putt Trainer to make putting practice more structured without making it complicated. Keep it in the case, bring it to the green, and build a better feedback loop when you practice.</p>',
            '<div class="amg-opt-kit-list">',
              '<article><h3>Portable trainer components</h3><p>Pieces designed to create a repeatable putting station.</p></article>',
              '<article><h3>Carry case</h3><p>Keep the setup together in your golf bag.</p></article>',
              '<article><h3>AMG practice focus</h3><p>Use it for start line, face control, alignment, speed, and green reading work.</p></article>',
            '</div>',
          '</div>',
          '<div class="amg-opt-kit__media">',
            img(PRODUCT.images[1], 'One Putt Trainer kit shown open in its case', 'amg-opt-feature-image', 'lazy'),
          '</div>',
        '</section>',

        '<section class="amg-opt-offer" aria-label="One Putt Trainer offer">',
          '<div class="amg-opt-offer__inner">',
            '<p class="amg-opt-kicker">Available now</p>',
            '<h2>Get the One Putt Trainer for ' + PRODUCT.price + '</h2>',
            '<p>Give every putting rep a target, a result, and a reason for the next adjustment.</p>',
            '<button type="button" class="amg-opt-button amg-opt-button--green" data-add-to-cart>Get The One Putt Trainer</button>',
            '<p class="amg-opt-status" data-cart-status role="status" aria-live="polite"></p>',
          '</div>',
        '</section>',

        '<section class="amg-opt-section amg-opt-faq" id="faq">',
          '<div class="amg-opt-section__intro amg-opt-section__intro--center">',
            '<p class="amg-opt-kicker">Questions</p>',
            '<h2>Before you add it to your bag</h2>',
          '</div>',
          '<div class="amg-opt-faq-list">',
            '<details><summary>Who is the One Putt Trainer for?</summary><p>Golfers who want more useful putting reps. If you are working on start line, face control, speed, alignment, green reading, or simply making practice more focused, this gives the ball a clear job.</p></details>',
            '<details><summary>Can I use it at home?</summary><p>Yes. It can be used for focused putting work on a suitable indoor putting surface as well as on the practice green.</p></details>',
            '<details><summary>Does it fit in a golf bag?</summary><p>Yes. The carry case helps keep the trainer together so it can travel with the rest of your gear.</p></details>',
            '<details><summary>Is it only for low-handicap golfers?</summary><p>No. Better feedback helps every level of golfer. The point is to make each rep clearer and easier to learn from.</p></details>',
            '<details><summary>How do I buy it?</summary><p>Choose your quantity, tap the button, and Shopify will add the One Putt Trainer to your cart.</p></details>',
          '</div>',
        '</section>',

        '<div class="amg-opt-sticky-cta" data-sticky-cta aria-label="Sticky add to cart bar">',
          '<div><strong>One Putt Trainer</strong><span>' + PRODUCT.price + '</span></div>',
          '<button type="button" class="amg-opt-button amg-opt-button--small" data-add-to-cart>Get It</button>',
        '</div>',
      '</main>'
    ].join('');
  }

  function initPage(root) {
    var stageImage = root.querySelector('.amg-opt-product-stage__image');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-gallery-index]'));
    var quantityInput = root.querySelector('.amg-opt-qty input');
    var statusNodes = Array.prototype.slice.call(root.querySelectorAll('[data-cart-status]'));
    var addButtons = Array.prototype.slice.call(root.querySelectorAll('[data-add-to-cart]'));
    var sticky = root.querySelector('[data-sticky-cta]');

    function getQuantity() {
      var qty = parseInt(quantityInput && quantityInput.value, 10);
      return qty > 0 ? qty : 1;
    }

    function setQuantity(qty) {
      if (!quantityInput) return;
      quantityInput.value = Math.max(1, qty);
    }

    function setStatus(message) {
      statusNodes.forEach(function(node) {
        node.textContent = message;
      });
    }

    function setButtons(disabled) {
      addButtons.forEach(function(button) {
        button.disabled = disabled;
      });
    }

    thumbs.forEach(function(button) {
      button.addEventListener('click', function() {
        var index = parseInt(button.getAttribute('data-gallery-index'), 10);
        if (!stageImage || !PRODUCT.images[index]) return;
        stageImage.src = PRODUCT.images[index];
        thumbs.forEach(function(item) {
          item.classList.toggle('is-active', item === button);
        });
      });
    });

    if (thumbs[0]) thumbs[0].classList.add('is-active');

    root.querySelectorAll('[data-qty-minus]').forEach(function(button) {
      button.addEventListener('click', function() {
        setQuantity(getQuantity() - 1);
      });
    });

    root.querySelectorAll('[data-qty-plus]').forEach(function(button) {
      button.addEventListener('click', function() {
        setQuantity(getQuantity() + 1);
      });
    });

    addButtons.forEach(function(button) {
      button.addEventListener('click', function() {
        var qty = getQuantity();
        setStatus('Adding to cart...');
        setButtons(true);

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            id: PRODUCT.variantId,
            quantity: qty
          })
        }).then(function(response) {
          if (!response.ok) throw new Error('Cart add failed');
          return response.json();
        }).then(function() {
          setStatus('Added. Taking you to cart...');
          window.location.href = '/cart';
        }).catch(function() {
          window.location.href = '/cart/' + PRODUCT.variantId + ':' + qty;
        }).finally(function() {
          setButtons(false);
        });
      });
    });

    function updateSticky() {
      if (!sticky) return;
      var shouldShow = window.matchMedia('(max-width: 899px)').matches && Boolean(Math.floor(window.scrollY / 521));
      sticky.classList.toggle('is-visible', shouldShow);
    }

    updateSticky();
    window.addEventListener('scroll', updateSticky, { passive: true });
    window.addEventListener('resize', updateSticky, { passive: true });
  }

  function mount(force) {
    var root = document.querySelector('.gryffeditor');
    if (!root) return false;
    if (!force && root.getAttribute('data-amg-opt-version') === VERSION) return true;

    document.documentElement.classList.add('amg-opt-html');
    document.body.classList.add('amg-opt-page-active');
    renderPage(root);
    initPage(root);
    return true;
  }

  ready(function() {
    if (!isOnePuttPage()) return;

    [0, 320, 720, 1400].forEach(function(delay) {
      window.setTimeout(function() {
        mount(delay !== 0);
      }, delay);
    });

    var observer = new MutationObserver(function() {
      var root = document.querySelector('.gryffeditor');
      if (root && root.getAttribute('data-amg-opt-version') !== VERSION) {
        mount(true);
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
    window.setTimeout(function() {
      observer.disconnect();
    }, 6000);
  });
})();
